import React, { useState } from 'react';
import { Modal, Button, Row, Col, Image } from 'react-bootstrap';
import { useCollectionData } from 'react-firebase-hooks/firestore';
import { TextInput } from 'evergreen-ui';
import firebase from 'firebase';
import 'firebase/firestore';
import Expo from 'expo-server-sdk';

import './notification.scss';

let expo = new Expo();
const PUSH_ENDPOINT = 'https://exp.host/--/api/v2/push/send';

export default function PushNotification(props) {

    const { show, close } = props;
    const { title, id } = props.article;
    const [notificationTitle, updateTitle] = useState(title);
    const [tokens, loading, error] = useCollectionData(firebase.firestore().collection('tokens'),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        });

    const handlePushNotification = (e) => {
        e.preventDefault();

        //console.log('tokens:', tokens);

        // let messages = [];
        for (let pushToken of tokens) {
            if (!Expo.isExpoPushToken(pushToken.push_token)) {
                console.error(`Push token ${pushToken.push_token} is not a valid Expo push token`);
                continue;
            }

            console.log('token:', pushToken.push_token);

            let data = {
                "to": pushToken.push_token,
                "title": "essentielFoot",
                "body": title,
                "sound": "default",
                "data": { "id": id }
            }

            fetch(PUSH_ENDPOINT, {
                'mode': 'no-cors',
                'method': 'POST',
                'headers': {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            }).catch(err => console.log(err));

            // Construct a message (see https://docs.expo.io/versions/latest/guides/push-notifications.html)
            // messages.push({
            //     to: pushToken.push_token,
            //     sound: 'default',
            //     body: title,
            //     data: { "id": id }
            // });
        }

        close();
        alert('Notification envoyée');
    }

    return (
        <Modal show={show} onHide={close} className="notification-modal">
            <Modal.Header>Push Notification</Modal.Header>

            <Modal.Body>
                <Row>
                    <TextInput
                        name="title-input"
                        className="title-input"
                        placeholder="Titre"
                        onChange={updateTitle}
                        value={notificationTitle}
                    />
                </Row>
                <Row>
                    <Button onClick={handlePushNotification}>Envoyer</Button>
                </Row>
            </Modal.Body>
        </Modal>
    )
}